import Combobox from '@/libs/components/src/lib/form/Combobox';
import { Region } from '@chiroup/core/types/Condition.type';
import { FormError } from '@chiroup/core/types/ErrorResponse.type';
import React from 'react';
import { REGION_OPTIONS } from '../../../../constants';

type Props = {
  onChange: (val: Region | Region[]) => void;
  value?: string | string[];
  limit?: number;
  label?: string;
  showLabel?: boolean;
  className?: string;
  errors?: FormError;
  disabled?: boolean;
  loading?: boolean;
};

const RegionSelect: React.FC<Props> = ({
  onChange,
  value,
  limit,
  label = 'Region',
  showLabel = false,
  className = 'flex-1 min-w-0',
  errors,
  disabled = false,
  loading = false,
}) => {
  return (
    <Combobox<string | string[]>
      name="region"
      label={label}
      showLabel={showLabel}
      className={className}
      options={REGION_OPTIONS}
      onChange={onChange}
      value={value}
      limit={limit}
      errors={errors}
      placeholder="Select region"
      disabled={disabled}
      loading={loading}
    />
  );
};

export default RegionSelect;
